import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public userName;
  public userImage;
  // public cred = {poolId: localStorage.getItem('poolId') , region: localStorage.getItem('region')}
   constructor(private router: Router) { }
 
   ngOnInit() {
     this.userName = localStorage.getItem('userName');
    // console.log(this.userImage)
      if(localStorage.getItem('pic') != null){
        this.userImage = localStorage.getItem('pic')
      }else{
        this.userImage = "https://s3.amazonaws.com/admin-panel-aws/dummy.jpeg";
      }
   }
 
   viewProfile(): void {
    this.router.navigate(["/user-profile", { userName: this.userName}]);
  }
 }